import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import ItinerantActions from "@/components/ItinerantActions";
import FightingForFishermen from "@/components/FightingForFishermen";
import ProjectAction from "@/components/ProjectAction";
import Statistics from "@/components/Statistics";
import RegistrationForm from "@/components/RegistrationForm";
import Directors from "@/components/Directors";
import Partners from "@/components/Partners";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

function App() {
  return (
    <div data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <ItinerantActions />
        <FightingForFishermen />
        <ProjectAction />
        <Statistics />
        <RegistrationForm />
        <Directors />
        <Partners />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
